import React from 'react';

import { hot } from 'react-hot-loader/root';

import GoogleWorkspaceLandingHelmet from 'common/helmets/GoogleWorkspaceLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';

import CannyLogoIcon from 'img/canny-icon.svg';
import GoogleLogo from 'img/google-icon.svg';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const GoogleWorkspaceLanding = () => {
  return (
    <div className="integrationsLanding withoutImage">
      <GoogleWorkspaceLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={GoogleLogo}
                alt="Google Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Google Workspace Integration</h1>
              <p className="subtitle">
                Our Google Workspace integration lets you import users to Canny and track their
                feedback.
              </p>
              <div className="links">
                <InstallExtensionButton
                  installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fgoogle-workspace"
                  installButtonText="Install Google Workspace"
                />
                <a
                  href="https://help.canny.io/en/articles/4228880-google-workspace-g-suite-integration"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Automatically import your Google Workspace users</h2>
              <p className="subtitle">
                Specify which user groups you want imported and we’ll add them to Canny right away.
                Plus, we’ll add new users as they’re added to your groups.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Easily manage Canny access</h2>
              <p className="subtitle">
                Canny updates your users as you make changes to your Google Workspace. As soon as
                someone leaves your organization, we immediately remove Canny permissions.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default hot(GoogleWorkspaceLanding);
